<template>
  <div class="maintenance">
    <template v-if="isBestWin">
      <div class="maintenance__content-block">
        <div>ประชาสัมพันธ์:</div>
        <div>เรียนท่านสมาชิกทุกท่าน</div>
        <div>
          เนื่องจากวันที่2 พฤษภาคม 2566 เวลา 11:00 น. (เวลาไทย)ทางเว็บของFin99ได้อัพเดทเว็บใหม่
          ได้เพิ่มเกมส์มากกว่าเดิมและรูปแบบการเล่นที่หลากหลายมากยิ่งขึ้น สามารถสมัครผ่านทางเว็บได้ที่
          <a href="https://www.fin99.org" target="_blank">www.fin99.org</a>
        </div>
        <div>
          (รบกวนแจ้งยูสเซอร์ใหม่ให้เจ้าหน้าที่ทราบ เพื่อทำการอัพเดทยอดเก้าไปยังยูเซอร์ใหม่นะคะ)หากมีข้อสงสัย
          สอบถามเพิ่มเติมได้ที่ ID line @fin-99 หรือโทร092-3200882
        </div>
      </div>
    </template>
    <template v-else>
      <div class="maintenance__content-block" v-for="content in contentList" :key="content.lang">
        <p>
          <span v-html="content.htmlContent1"></span>
          <span class="text-red">{{ siteMaintainTimeStart }} ~ {{ siteMaintainTimeEnd }} (HK Time GMT +8)</span>
          <span v-html="content.htmlContent2"></span>
        </p>
      </div>
      <button class="ui-btn" @click="clickServiceHandler">Contact with online service</button>
      <footer class="maintenance__footer">
        <div class="maintenance__footer__logo">
          <ul class="maintenance__footer__ul">
            <li class="maintenance__footer__logo1"></li>
            <li class="maintenance__footer__logo2"></li>
            <!-- <li class="maintenance__footer__logo3"></li> -->
            <li class="maintenance__footer__logo4"></li>
            <li
              class="maintenance__footer__logo5"
              :style="{ 'background-image': `url(${siteResourceUrlMaintain}/footer_logo5.png)` }"
            ></li>
            <li class="maintenance__footer__logo6"></li>
          </ul>
        </div>
        <div class="maintenance__footer__copyright">Copyright © 2014 {{ siteTitle }} All Rights Reserved</div>
      </footer>
    </template>
  </div>
</template>

<script>
import mixinStyleLoader from '@/mixins/_styleLoader';
import { mapGetters } from 'vuex';
import mixinContact from '@/mixins/contact';

export default {
  name: 'Maintenance',
  mixins: [mixinStyleLoader, mixinContact],
  computed: {
    ...mapGetters([
      'siteFullCss',
      'siteResourceUrlMaintain',
      'siteTitle',
      'siteIsActive',
      'siteMaintainTimeStart',
      'siteMaintainTimeEnd',
      'siteMainDomain',
    ]),
    isBestWin() {
      return this.siteMainDomain === 'THRY1688E_net';
    },
  },
  data() {
    return {
      contentList: [
        {
          lang: 'zh-tw',
          htmlContent1: `系統目前正在維護中，維護時間為:<br />`,
          htmlContent2: `<br />請您耐心等待，不便之處，我們為此十分抱歉!`,
        },
        {
          lang: 'zh-cn',
          htmlContent1: `系统目前正在维护中，维护時间为:<br />`,
          htmlContent2: `<br /> 请您耐心等待，不便之处，我们为此十分抱歉!`,
        },
        {
          lang: 'en-us',
          htmlContent1: `The system is currently maintenance,maintenance time is:<br />`,
          htmlContent2: `<br />  Please be patient, inconvenience,we therefore very sorry!`,
        },
        {
          lang: 'th-th',
          htmlContent1: `เนื่องจากขณะนี้ระบบอยู่ในช่วงปิดปรับปรุง！ช่วงเวลาปิดปรับปรุง:<br />`,
          htmlContent2: `<br />  ขออภัยในความไม่สะดวกด้วยครับ/ค่ะ`,
        },
      ],
    };
  },
  mounted() {
    //* 非維護時，轉去首頁
    if (this.siteIsActive) {
      this.$router.replace({ name: 'Home' });
    }

    // import(`@/styles/${this.siteFullCss}/maintenance.scss`);
    this.importStyleByFilename('maintenance');
  },
};
</script>

<style lang="scss" scoped>
.maintenance {
  font-size: 2rem;
  line-height: 50px;

  &__content-block {
    margin-top: 30px;
  }
}
</style>
